<template>
  <div id="product">
    <CommonHeader></CommonHeader>
    <div class="banner">
      <img src="/images/banner2.png" />
    </div>
    <div class="main4 wrap">
      <div v-for="(item, index) in main4.header" :key="index" :class="'main4-title'+index">
        <span v-text="item.title"></span>
      </div>
      <ul class="main4-ul clearfix">
        <li v-for="(item, index) in main4.body" :key="index" :class="'main4-ul-li'+ index">
          <div class="main4-ul-li-left">
            <img :src="'/images/img-m4-'+ index +'.png'" />
          </div>
          <div class="main4-ul-li-right">
            <h3 class="main4-ul-li-title" v-text="item.title"></h3>
            <p class="main4-ul-li-content" v-text="item.content"></p>
          </div>
        </li>
      </ul>
    </div>
    <div class="main5">
      <div v-for="(item, index) in main5.header" :key="index" :class="'main5-title'+index">
        <span v-text="item.title"></span>
      </div>
      <ul class="wrap main5-ul">
        <li v-for="(item, index) in main5.body" :key="index">
          <div class="icon"><img :src="'/images/img-m5-'+ index +'.png'" /></div>
          <h3 class="main5-ul-li-title" v-text="item.title"></h3>
          <p class="main5-ul-li-content" v-text="item.content"></p>
        </li>
      </ul>
    </div>
    <div class="main6 wrap">
      <div v-for="(item, index) in main6.header" :key="index" :class="'main6-title'+index">
        <span v-text="item.title"></span>
      </div>
      <ul class="wrap main6-ul clearfix">
        <li class="main6-ul-img"><img src="/images/img-m5-phone.png" /></li>
        <li class="main6-ul-li" :class="'main6-ul-li'+ index" v-for="(item, index) in main6.body" :key="index">
          <h3 class="main6-ul-li-title" v-text="item.title"></h3>
          <p class="main6-ul-li-content" v-text="item.content"></p>
        </li>
      </ul>
    </div>
    <CommonFooter></CommonFooter>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
import CommonFooter from "@/components/CommonFooter.vue"

export default {
  name: "product",
  components: {
    CommonHeader,
    CommonFooter
  },

  data() {
    return {
      main4: {
        header: [],
        body: [],
      },
      main5: {
        header: [],
        body: [],
      },
      main6: {
        header: [],
        body: [],
      },
    }
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.$http
        .get("/data/product.json")
        .then((response) => {
          if (response.data) {
            this.main4.header = response.data.main4.header
            this.main4.body = response.data.main4.body

            this.main5.header = response.data.main5.header
            this.main5.body = response.data.main5.body

            this.main6.header = response.data.main6.header
            this.main6.body = response.data.main6.body
          }
        })
        .catch(err => {
          console.log(err);
        })
    }
  }
};
</script>

<style lang="less">
.banner {
  width: 100%;

  img {
    width: 100%;
    height: auto;
  }
}

.main4 {
  height: 673px;
  padding: 70px 62px 12px;

  .main4-title0 {
    font-size: 44px;
    line-height: 58px;
    color: #333;
  }

  .main4-title1 {
    width: 704px;
    height: 48px;
    margin: 10px 0 59px;
    font-size: 16px;
    line-height: 24px;
    color: #999;
    overflow: hidden;
  }

  .main4-ul {
    li {
      float: left;
      width: 523px;
      height: 140px;
      margin-bottom: 91px;

      .main4-ul-li-left {
        float: left;
        width: 140px;
        height: 140px;
        padding: 45px;
        border-radius: 50%;
        background: #fff;
        box-shadow:0px 0px 24px 0px rgba(0, 0, 0, 0.04);
      }

      .main4-ul-li-right {
        float: right;
        width: 353px;

        .main4-ul-li-title {
          margin: 0 0 23px;
          font-size: 14px;
          color: #333;
          line-height: 16px;
        }

        .main4-ul-li-content {
          width: 353px;
          height: 72px;
          line-height: 24px;
          font-size: 16px;
          color: #999;
          overflow: hidden;
        }
      }
    }

    .main4-ul-li1,
    .main4-ul-li3 {
      margin-left: 30px;
    }
  }
}

.main5 {
  height: 495px;
  min-width: 100%;
  background: url("/images/bg-main5.png") center no-repeat;
  background-size: cover;

  .main5-title0 {
    padding: 60px 0 15px;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    color: #fff;

      span {
        position: relative;

        &:after {
          display: block;
          content: "";
          position: absolute;
          left: 38%;
          bottom: -15px;
          width: 28px;
          height: 2px;
          background: #fff;
        }
      }
  }

  .main5-ul {
    padding-top: 60px;

    li {
      float: left;
      width: 378px;
      height: 247px;
      padding: 38px;
      margin-left: 148px;
      background: #fff;
      box-shadow: 0px 6px 10px 0px rgba(235, 236, 237, 1);
      border-radius: 6px;

      &:not(:first-child) {
        //margin-left: 33px;
      }

      .main5-ul-li-title {
        padding: 34px 0 23px;
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }

      .main5-ul-li-content {
        font-size: 14px;
        height: 24px;
        color: #999;
      }
    }
  }
}

.main6 {
  height: 800px;
  padding: 50px 0;
  text-align: center;

  .main6-title0 {
    font-size: 44px;
    color: #333;
  }

  .main6-title1 {
    width: 705px;
    margin: 20px auto;
    line-height: 24px;
    font-size: 16px;
    color: #999;
  }

  .main6-ul {
    position: relative;
    width: 871px;
    height: 520px;
    margin-top: 52px;

    .main6-ul-img {
      width: 245px;
      height: 520px;
      position: absolute;
      top: 0;
      left: 313px;
      right: 313px;
      bottom: 0;

      img {
        max-width: 100%;
        height: auto;
      }
    }

    .main6-ul-li {
      float: left;
      width: 253px;

      .main6-ul-li-title {
        margin: 55px 0 23px;
        font-size: 14px;
        color: #8925fb;
      }

      .main6-ul-li-content {
        height: 110px;
        font-size: 14px;
        line-height: 22px;
        color: #999;
        overflow: hidden;
      }
    }

    .main6-ul-li0,
    .main6-ul-li1 {
      //margin-top: 30px;
    }

    .main6-ul-li1,
    .main6-ul-li3 {
      margin-left: 365px;
    }
  }
}
</style>
